import {EditModel} from "./EditModel";
import {Employee} from "../../entities/Employee";
import {EmployeeService} from "../../services/EmployeeService";
import {PrintJobService} from "../../services/PrintJobService";
import {NotificationService} from "../../services/NotificationService";
import {Asset} from "../../entities/Asset";
import {Template} from "../../entities/Template";
import {PrintJob} from "../../entities/PrintJob";

export class EditEmployeeModel extends EditModel<Employee> {
    entityId:number;
    static $inject = ['$q','EmployeeService','PrintJobService','NotificationService'];
    constructor($q:ng.IQService, public service:EmployeeService,
                public printjobService:PrintJobService, public notifyService:NotificationService){
        super($q, service, Employee);
    }
    verifyData():ng.IPromise<boolean>{
        var rfidPromise = this.entity.rfidTag != null && this.entity.rfidTag.length > 0 ? this.service.getByRfid(this.entity.rfidTag) : this.$q.when<Asset>(null);
        return this.$q.all([this.service.getByEmail(this.entity.email), rfidPromise]).then((data) => {
        var nameEmployee:Employee = data[0];
        var rfidEmployee:Employee = data[1];
        if(nameEmployee != null && nameEmployee.id != this.entity.id)
        {
          this.notifyService.notifyError("Please choose a unique employee email.");
          return this.$q.when<boolean>(false);
        }
        else if(rfidEmployee != null && rfidEmployee.id != this.entity.id)
        {
            this.notifyService.notifyError("This RFID value is already associated with employee " + rfidEmployee.email);
          return this.$q.when<boolean>(false);
        }
        else
          return this.$q.when<boolean>(true);
      })
    }   
    print(template: Template) {
        var mainPromise: ng.IPromise<any> = null;
        if (this.entityId == null)
            mainPromise = this.service.insert(this.entity);
        else
            mainPromise = this.$q.when<number>(this.entityId);
        mainPromise.then((entityId) => {
            if (this.entityId == null)
                this.entity.id = entityId;
            this.entityId = entityId;
            var printJob: PrintJob = new PrintJob(null, this.entity.id, "Employee", template.id, template.useWithService);
            return this.printjobService.print(printJob);
        })
            .then((newId) => {
                return this.printjobService.get(newId).then((printJob) => {
                    this.entity.rfidTag = printJob.generatedRfid;
                })
                this.notifyService.notify("Print Job Scheduled Successfully.");
            })
            .catch((exc) => {
                this.notifyService.notifyError("Printing Error", exc);
            });
    }
}
